// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Milestone details (inside a project's Milestone tab). Scoped under .milestone-details. */

.milestone-details {
  min-width: 0;
  padding-bottom: var(--ds-space-4);
}

.milestone-details .milestone-details__header {
  margin-bottom: var(--ds-space-4);
}

.milestone-details .milestone-details__heading {
  min-width: 0;
}

.milestone-details .milestone-details__back {
  flex-shrink: 0;
  font-size: 20px;
}

/* The arrow icon points "back" in reading direction. */
[dir="rtl"] .milestone-details .milestone-details__back svg {
  transform: scaleX(-1);
}

.milestone-details .milestone-details__title {
  margin: 0;
  font-size: var(--ds-title-size);
  font-weight: 700;
  color: var(--ds-text);
  overflow-wrap: anywhere;
}

.milestone-details .milestone-details__tasks-bar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: var(--ds-space-3);
}
`, "",{"version":3,"sources":["webpack://./src/commons/Projects/Milestones/MilestoneDetails.css"],"names":[],"mappings":"AAAA,2FAA2F;;AAE3F;EACE,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gCAAgC;AAClC","sourcesContent":["/* Milestone details (inside a project's Milestone tab). Scoped under .milestone-details. */\n\n.milestone-details {\n  min-width: 0;\n  padding-bottom: var(--ds-space-4);\n}\n\n.milestone-details .milestone-details__header {\n  margin-bottom: var(--ds-space-4);\n}\n\n.milestone-details .milestone-details__heading {\n  min-width: 0;\n}\n\n.milestone-details .milestone-details__back {\n  flex-shrink: 0;\n  font-size: 20px;\n}\n\n/* The arrow icon points \"back\" in reading direction. */\n[dir=\"rtl\"] .milestone-details .milestone-details__back svg {\n  transform: scaleX(-1);\n}\n\n.milestone-details .milestone-details__title {\n  margin: 0;\n  font-size: var(--ds-title-size);\n  font-weight: 700;\n  color: var(--ds-text);\n  overflow-wrap: anywhere;\n}\n\n.milestone-details .milestone-details__tasks-bar {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: var(--ds-space-3);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
